import type { NextPage } from 'next'
import { IndexPageVariant3 } from '@/components/variants/pages/index-3'
import home_page_img from '@/public/images/site-preview.gif'
import { SEO } from '@/components/common/SEO'

const structuredData = {
  '@context': 'https://schema.org',
  'type': 'EducationalOrganization',
  'name': 'Commit Action',
  'url': 'https://www.commitaction.com/',
  'logo': '',
  'sameAs': [
    'https://www.facebook.com/commitaction/',
    'https://www.linkedin.com/company/commit-action',
    'https://www.instagram.com/commitaction/',
    'https://twitter.com/CommitAction'
  ]
}

type Props = {
  prices: Prices
}

type Prices = {
  annual: number,
  monthly: number
}
//
const Home: NextPage<Props> = ({ prices }) => {
  return (
    <>
      <SEO
        title="Guaranteed to keep you accountable"
        description="Get the power of structured accountability & strategic planning with Commit Action. Join today to achieve more & turn your big ideas into tangible results."
        canonicalUrl={process.env.NEXT_PUBLIC_SITE as string}
        ogImageUrl={`${process.env.NEXT_PUBLIC_SITE}${home_page_img.src}`}
        structuredData={structuredData}
      />
      <IndexPageVariant3 prices={prices} />
    </>
  )
}

export async function getStaticProps() {
  const response = await fetch(`${process.env.APP_URL}/pricing`, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })

  const json = await response.json()

  return {
    props: {
      prices: json
    }
  }
}

export default Home
